import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import SaveIcon from '@material-ui/icons/Save';
import { instanceAxios } from '../../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '',
    overflow: 'auto',
    width: '95%',
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
}));

function ConfiguracaoNotas() {
  const classes = useStyles();
  const [xmei, setXmei] = useState({});
  const [ready, setReady] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [caracteristicasPrefeitura, setCaracteristicasPrefeitura] = useState({
    regimesEspecialTributacao: [],
  });

  useEffect(() => {
    instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/xmei`)
      .then((res) => {
        setReady(true);
        setXmei(res.data.xmei);
        setCaracteristicasPrefeitura(res.data.caracteristicasPrefeitura);
        console.log(res.data.xmei);
        console.log(res.data.caracteristicasPrefeitura);
      })
      .catch((err) => {
        console.log(err);
        setReady(true);
      });
  }, []);

  const clickAlert = () => {
    setOpenAlert(false);
    setTipoAlert('');
    setMessageAlert('');
  };

  const handleSalvar = () => {
    instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/xmei`, xmei)
      .then((res) => {
        setReady(true);
        setOpenAlert(true);
        setTipoAlert('success');
        setMessageAlert('Dados Alterados Com Sucesso!');
      })
      .catch((err) => {
        console.log(err);
        setReady(true);
        setOpenAlert(true);
        setTipoAlert('error');
        setMessageAlert('Erro ao Alterar Dados Tente Novamente mais tarde!');
      });
  };

  return (
    <>
      <Typography variant="h3" gutterBottom>
        Configuração
      </Typography>
      <Collapse in={openAlert}>
        <Alert severity={tipoAlert} onClick={clickAlert}>
          {messageAlert}
        </Alert>
      </Collapse>
      <Collapse in={ready}>
        <Grid container spacing={3} style={{ paddingTop: '3%' }}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="razao_social"
              label="Razão Social"
              variant="outlined"
              fullWidth
              value={xmei.razao_social}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.razao_social = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="cnpj"
              label="CNPJ"
              variant="outlined"
              value={xmei.cnpj}
              fullWidth
              onChange={(event) => {
                const obj = { ...xmei };
                obj.cnpj = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="cnae"
              label="CNAE"
              variant="outlined"
              fullWidth
              value={xmei.cnae}
              helperText={caracteristicasPrefeitura.helpCNAE}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.cnae = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="inscricao_municipal"
              label="Inscrição Municipal"
              variant="outlined"
              value={xmei.inscricao_municipal}
              helperText={caracteristicasPrefeitura.helpInscricaoMunicipal}
              fullWidth
              onChange={(event) => {
                const obj = { ...xmei };
                obj.inscricao_municipal = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              id="descricao_servico"
              label="Descriçao Serviço"
              variant="outlined"
              value={xmei.descricao_servico}
              helperText={caracteristicasPrefeitura.helpDescricaoServico}
              fullWidth
              multiline
              rows={2}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.descricao_servico = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="codigo_servico_municipal"
              label="Código Serviço Municipal"
              variant="outlined"
              fullWidth
              helperText={caracteristicasPrefeitura.helpCodigoServicoMunicipal}
              value={xmei.codigo_servico_municipal}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.codigo_servico_municipal = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="regime_especial_tributo"
              label="Regime Especial Tributo"
              select
              variant="outlined"
              value={xmei.regime_especial_tributacao}
              helperText={
                caracteristicasPrefeitura.helpRegimeEspecialTributacao
              }
              fullWidth
              onChange={(event) => {
                const obj = { ...xmei };
                obj.regime_especial_tributacao = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              {caracteristicasPrefeitura.regimesEspecialTributacao.map(
                (option) => (
                  <MenuItem key={option.codigo} value={option.codigo}>
                    {option.nome}
                  </MenuItem>
                )
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h5" color="textSecondary">
              Endereço
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="cep"
              label="CEP"
              variant="outlined"
              fullWidth
              value={xmei.cep}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.cep = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              id="ibge"
              label="Código IBGE"
              variant="outlined"
              fullWidth
              value={xmei.ibge}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.ibge = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="logradouro"
              label="Logradouro"
              variant="outlined"
              fullWidth
              value={xmei.logradouro}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.logradouro = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="numero"
              label="Número"
              variant="outlined"
              fullWidth
              value={xmei.numero}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.numero = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="complemento"
              label="Complemento"
              variant="outlined"
              fullWidth
              value={xmei.complemento}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.complemento = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="bairro"
              label="Bairro"
              variant="outlined"
              fullWidth
              value={xmei.bairro}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.bairro = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="cidade"
              label="Cidade"
              variant="outlined"
              fullWidth
              value={xmei.cidade}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.cidade = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="estado"
              label="Estado"
              variant="outlined"
              fullWidth
              value={xmei.estado}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.estado = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h5" color="textSecondary">
              Retenção Federal
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="aliquota_iss"
              label="Aliquota ISS"
              variant="outlined"
              type="number"
              fullWidth
              value={xmei.aliquota_iss}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.aliquota_iss = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="valor_pis"
              label="Valor PIS"
              variant="outlined"
              type="number"
              fullWidth
              value={xmei.valor_pis}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.valor_pis = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="valor_cofins"
              label="Valor Cofins"
              variant="outlined"
              type="number"
              fullWidth
              value={xmei.valor_cofins}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.valor_cofins = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="valor_csll"
              label="Valor CSLL"
              variant="outlined"
              type="number"
              fullWidth
              value={xmei.valor_csll}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.valor_csll = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="valor_inss"
              label="Valor INSS"
              variant="outlined"
              type="number"
              fullWidth
              value={xmei.valor_inss}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.valor_inss = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <TextField
              id="valor_ir"
              label="Valor IR"
              variant="outlined"
              type="number"
              fullWidth
              value={xmei.valor_ir}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.valor_ir = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <TextField
              id="retido_na_fonte"
              label="Retido na Fonte"
              select
              fullWidth
              variant="outlined"
              value={xmei.retido_na_fonte}
              onChange={(event) => {
                const obj = { ...xmei };
                obj.retido_na_fonte = event.target.value;
                setXmei(obj);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem key="true" value="true">
                Sim
              </MenuItem>
              <MenuItem key={false} value={false}>
                Não
              </MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9}>
            <div align="right">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSalvar}
                startIcon={<SaveIcon />}
              >
                Salvar
              </Button>
            </div>
          </Grid>
        </Grid>
      </Collapse>
      <Collapse in={!ready}>
        <CircularProgress className={classes.loading} />
      </Collapse>
    </>
  );
}

export default ConfiguracaoNotas;
